const exists = val => val !== null && val !== undefined && val !== '' && val !== 'undefined';

export default exists;
